import { loadable } from '../../../utils';

export const Bar = loadable(() => import('./Bar'), {});
